export const containsAll = (needles, haystack) => {
  for (var i = 0, len = needles.length; i < len; i++) {
    if (haystack.indexOf(needles[i]) !== -1) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/helpers/contains.js